import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: "",
    //   redirect: "/"
    // },
    {
      path: "/",
      component: () => import("@/views/index/index.vue") // 首页
    },
    {
      path: "/disable",
      component: () => import("@/views/index/disable.vue") // 账号被禁用
    },
    {
      path: "/reporter",
      component: () => import("@/views/reporter/reporter.vue") // 小记者
    },
    {
      path: "/apply",
      component: () => import("@/views/reporter/apply/apply.vue"), // 报名
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/thread",
      component: () => import("@/views/reporter/thread/thread.vue") // 线索
    },
    {
      path: "/contribute",
      component: () => import("@/views/reporter/contribute/contribute.vue") // 投稿
    },
    {
      path: "/actives",
      component: () => import("@/views/reporter/actives/actives.vue") // 活动
    },
    {
      path: "/activesDetails",
      component: () => import("@/views/reporter/actives/activesDetails.vue") // 活动详情
    },
    {
      path: "/record",
      component: () => import("@/views/reporter/record/record.vue") // 活动记录
    },
    {
      path: "/activesPay",
      component: () => import("@/views/reporter/activesPay/activesPay.vue") // 活动缴费
    },
    {
      path: "/search",
      component: () => import("@/views/search/search.vue") // 搜索
    },
    {
      path: "/my",
      component: () => import("@/views/my/my.vue") // 个人中心
    },
    {
      path: "/edit",
      component: () => import("@/views/my/edit/edit.vue") //编辑资料
    },
    {
      path: "/collect",
      component: () => import("@/views/my/collect/collect.vue") //我的收藏
    },
    {
      path: "/collectDetail",
      component: () => import("@/views/my/collect/collectDetail.vue") //我的收藏名师讲堂详情
    },
    {
      path: "/contributeShow",
      component: () => import("@/views/my/contribute/contribute.vue") //我的投稿
    },
    {
      path: "/integration",
      component: () => import("@/views/my/integration/integration.vue") //我的积分
    },
    {
      path: "/vlog",
      component: () => import("@/views/my/vlog/vlog.vue") //我的vlog
    },
    {
      path: "/school",
      component: () => import("@/views/school/school.vue") //校园频道首页
    },
    {
      path: "/schoolList",
      component: () => import("@/views/school/schoolList/schoolList.vue") //校园频道列表
    },
    {
      path: "/schoolImg",
      component: () => import("@/views/school/schoolImg/schoolImg.vue") //校园图片
    },
    {
      path: "/schoolDetail",
      component: () => import("@/views/school/schoolDetail/schoolDetail.vue") //校园详情
    },
    {
      path: "/recommendDetail",
      component: () =>
        import("@/views/school/recommendDetail/recommendDetail.vue") //校园详情-精彩推荐
    },
    {
      path: "/schoolLive",
      component: () => import("@/views/school/schoolsLive/schoolLive.vue") //校园直播
    },
    {
      path: "/consult",
      component: () => import("@/views/school/consult/consult.vue") //校园资讯
    },
    {
      path: "/checkstand",
      name: "checkstand",
      component: () => import("@/views/checkstand/checkstand.vue") //收银台
    },
    {
      path: "/expenditure",
      name: "expenditure",
      component: () => import("@/views/checkstand/expenditure.vue") //续费
    },
    {
      path: "/contribution",
      component: () => import("@/views/contribution/contribution.vue") //优质稿件
    },
    {
      path: "/contributionDetail",
      component: () => import("@/views/contribution/contributionDetail.vue") //优质稿件详情
    },
    {
      path: "/consultDetail",
      component: () => import("@/views/school/consult/consultDetail.vue") //资讯详情
    },
    {
      path: "/programaVideo",
      component: () => import("@/views/programa/programaVideo.vue") //栏目视频列表
    },
    {
      path: "/programDetail",
      component: () => import("@/views/programa/programaDetail.vue") //栏目新闻详情
    },
    {
      path: "/topTeacher",
      component: () => import("@/views/topTeacher/topTeacher.vue") //名师讲堂
    },
    {
      path: "/teacherDetail",
      component: () => import("@/views/topTeacher/teacherDetail.vue") //名师讲堂详情
    },
    {
      path: "/moment",
      component: () => import("@/views/qcSchool/moment.vue") //精彩瞬间
    },
    {
      path: "/momentDetail",
      component: () => import("@/views/qcSchool/momentDetail.vue") //精彩瞬间详情
    },
    {
      path: "/repoterActives",
      component: () =>
        import("@/views/reporter/repoterActives/repoterActives.vue") //小记者在行动
    },
    {
      path: "/repoterActivesDetail",
      component: () =>
        import("@/views/reporter/repoterActives/repoterActivesDetail.vue") //小记者在行动详情
    },
    {
      path: "/viewMoment",
      component: () => import("@/views/qcSchool/viewMoment.vue") //精彩看点
    },
    {
      path: "/viewMomentDetail",
      component: () => import("@/views/qcSchool/viewMomentDetail.vue") //精彩看点详情
    },
    {
      path: "/myVlog",
      component: () => import("@/views/reporter/myVlog/myVlog.vue") // vlog投稿
    },
    {
      path: "/myVlog2",
      component: () => import("@/views/reporter/myVlog/vlog2.vue") // vlog投稿
    },
    {
      path: "/mien",
      component: () => import("@/views/school/mien/mien.vue") //校园风采
    },
    // {
    //   path: "/mien2",
    //   component: () => import("@/views/school/mien/mien2.vue") //校园风采
    // },
    {
      path: "/mienDetail",
      component: () => import("@/views/school/mien/mienDetail.vue") //校园风采详情
    },
    {
      path: "/qcSchool",
      component: () => import("@/views/qcSchool/qcSchool.vue") //晴采校园
    },
    // 学习园地
    {
      path: "/learningCenter",
      component: () => import("@/views/learningCenter/learningCenter.vue") //商城首页
    },
    {
      path: "/education",
      component: () => import("@/views/learningCenter/education/education.vue") //周边教育
    },
    {
      path: "/particulars",
      component: () =>
        import("@/views/learningCenter/education/particulars.vue") //周边教育详情
    },
    {
      path: "/curriculm",
      component: () =>
        import("@/views/learningCenter/curriculum/curriculum.vue") //才艺课程
    },
    {
      path: "/courseDetails",
      component: () =>
        import("@/views/learningCenter/curriculum/courseDetails.vue") //才艺课程详情
    },
    {
      path: "/store",
      component: () => import("@/views/learningCenter/store/store.vue") //商铺详情
    },
    {
      path: "/shoppingCart",
      component: () => import("@/views/learningCenter/shoppingCart.vue") //购物车
    },
    {
      path: "/submitOrder",
      component: () =>
        import("@/views/learningCenter/orderForm/submitOrder.vue") //确认购物车订单
    },
    {
      path: "/particularsOrder",
      component: () => import("@/views/learningCenter/detailsOrder.vue") //确认详情订单
      // meta: {
      //   keepAlive: true // 需要被缓存
      // }
    },
    {
      path: "/payment",
      component: () => import("@/views/learningCenter/payment.vue") //支付
    },
    {
      path: "/payment-success",
      component: () => import("@/views/learningCenter/paymentSuccess.vue") //支付成功
    },
    {
      path: "/orderList",
      component: () => import("@/views/learningCenter/orderForm/orderList.vue") //我的订单
    },
    {
      path: "/wangeditor",
      component: () => import("../components/wangeditor.vue")
    },
    {
      path: "/payment-Popup",
      component: () => import("../views/reporter/payment.vue")
    },
    {
      path: "/applySuccess",
      component: () => import("@/views/reporter/apply/applySuccess.vue") //支付成功
    },
    {
      path:'/livePage',
      component:()=>import('@/views/livePage/livePage.vue')
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js